import { Action, isType, actionCreatorFactory } from "diy/redux/typedActions";
const actionCreator = actionCreatorFactory('diy/module/');
import StoreProvider from "diy/redux/StoreProvider";

// =====
// STATE
// =====
export interface AppState {
    modules: ModulesState;
}

interface ModuleState {
    moduleId: number;
    payload: {};
}

interface ModulesState {
    [moduleId: number]: ModuleState;
}

const initialState: ModulesState = {};

// ===============
// ACTION CREATORS
// ===============
type UpdatePayload  = {
    moduleId: number;
    partialPayload: {}
};
export const update = actionCreator<UpdatePayload>('UPDATE');
type LoadPayload  = {
    moduleId: number;
    moduleState: ModuleState
};
export const load = actionCreator<LoadPayload>('LOAD');

// =======
// REDUCER
// =======
function reducer(
    state: ModulesState = initialState,
    action: Action<any>
): ModulesState {
    if (isType(action, update)) {
        // TODO refactor to use an imutable lib or util
        let newState = Object.assign({}, state);
        newState[action.payload.moduleId] = Object.assign(
            {},
            newState[action.payload.moduleId]
        );
        let newModule = newState[action.payload.moduleId];
        let newPayload = Object.assign({}, newModule.payload, action.payload.partialPayload);
        newModule.payload = newPayload;
        return newState;
    }
    if (isType(action, load)) {
        let newState = Object.assign({}, state);
        newState[action.payload.moduleId] = action.payload.moduleState;
        return newState;
    }
    return state;
}

// ==============
// INITIALIZATION
// ==============
let initialized = false;
export function init(storeProvider: StoreProvider) {
    if (!initialized) {
        storeProvider.addReducer(reducer, "modules");
        initialized = true;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/index.tsx
 **/